export default {
  DirectNumber: 'Direct',
  MainCompanyNumber: 'Principal',
  CompanyNumber: 'Entreprise',
  CompanyFaxNumber: 'Fax',
  Blocked: 'Bloqué',
  from: 'De',
};
